<template>
    <div class="content d_f">
        
        <div class="news-data">

            <div class="news-head">
                <h2>{{texts.title}}</h2>
                <div class="news-desc d_f jc_sb">
                    <span>日期：{{texts.createTime}}</span>
                    <div class="link d_f ai_c jc_sb">
                        <span>分享至</span>
                        <a href="javascript:void"><img class="h_1" src="../../assets/xl.png" alt=""></a>
                        <a href="javascript:void"><img class="h_1" src="../../assets/wx.png" alt=""></a>
                    </div>
                </div>
            </div>

            <div class="news-text">
                <p>
                    {{texts.contents}}
                </p>
                <img v-for="item in texts.picList" :key="item.id" :src="item.url" alt="" class="text-img">
            </div>
            <!-- <div class="m-link">
                <a-divider>分享至</a-divider>
                <div class="d_f f_1 jc_sb ai_c">
                    <a href="javascript:void"><img class="h_1" src="../../assets/xl.png" alt=""><p>微信</p></a>
                    <a href="javascript:void"><img class="h_1" src="../../assets/wx.png" alt=""><p>QQ</p></a>
                    <a href="javascript:void"><img class="h_1" src="../../assets/xl.png" alt=""><p>微博</p></a>
                </div>
            </div> -->
        </div>

        <div class="push">
            <p>更多新闻</p>

            <div class="push-list">
                <newsCard 
                    v-for="item in newslist" 
                    :key="item.id" 
                    :link='"/news/details?id="+item.id' 
                    :date='"日期："+item.createTime' 
                    :title="item.title"
                    :img = "item.newsPicUrl"
                />
            </div>

        </div>


    </div>
</template>

<script>

import newsCard from '../../components/news-card/index'
import news from '../../api/news'
import axios from 'axios';
export default {
    components : {
        newsCard
    },
    data(){
        return {
            texts : {},
            newslist : [],
            id : ''
        }
    },
    created(){
        let id = this.$route.query.id;
        if(!id){
            // 直接从路由跳转过来的没有带任何参数的 返回新闻列表页
            this.$router.push({path:'/news'});
            return;
        }
        this.id = id
        this.getNews(this.id)
    },
    methods : {
        getNews(id){
            axios.all([
            news.selectByHomeId({
              id
           }),
           news.getHomeNews({
              num : 5
           })
        ]).then(axios.spread((details,newspage)=>{
            this.texts = details
            this.newslist = newspage
        }))
        }
    },
    watch: {
        $route:{
            handler:function(){
                let id = this.$route.query.id;
                this.getNews(id);
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .content{
        width: 1200px;
        margin: 80px auto 0;
        justify-content: space-between;
    }
    .push{
        width: 370px;
    }
    .news-data{
        width: 740px;
        .news-head{
            h2{
                font-size: 28px;
                line-height: 36px;
                margin-bottom: 30px;
            }
            .news-desc{
                margin-bottom: 30px;
                .link{
                    width: 120px;
                }
            }
        }
        .text-img{
            display: block;
            margin: 50px 0;
        }
        p{
            font-size: 14px;
        }
    }
    .m-link{
        display: none;
    }
    @media screen and (max-width: 750px){
        .push{
            display: none;
        }
        .content{
            width: 100% !important;
            margin:0 !important;
            padding: 0 5.319vw;
            justify-content: space-between;
        }
        .news-data{
            width: 100% !important;
            .news-head{
                h2{
                    margin-top: 5.319vw  !important;
                    margin-bottom: 5.319vw  !important;
                    font-size: 5.054vw !important;
                }
                span{
                    display: block;
                    text-align: right;
                    width: 100% ;
                    font-size: 3.458vw;
                    color: #ccc;
                }
                .news-desc{
                    .link{
                        display: none;
                    }
                }
            }
            .news-text{
                img{
                    width: 100% !important;
                    margin: 7.979vw 0 !important;
                }
                p{
                    font-size: 3.458vw !important;
                    line-height: 5.851vw;
                }
            }
        }
        .m-link{
            display: block !important;
            height: 28.723vw;
            width: 72.606vw;
            margin: auto;
            a{
                text-align: center;
                font-size: 0.2364rem;
                color: #000;
            }
        }
    }
</style>